export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        return false;
    }

    if (Notification.permission === 'granted') {
        return true;
    }

    if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        return permission === 'granted';
    }

    return false;
};

export const sendNotification = (title, options = {}) => {
    if (!('Notification' in window)) return;

    if (Notification.permission === 'granted') {
        const notification = new Notification(title, {
            icon: '/logo192.png', // Uses the standard create-react-app logo or your app icon
            badge: '/logo192.png',
            ...options
        });

        notification.onclick = function (event) {
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            window.focus(); // try to focus the window
            notification.close();
            if (options.onClick) {
                options.onClick();
            }
        };
    }
};
